// Tinymce import, see: https://www.tiny.cloud/docs/advanced/usage-with-module-loaders/
// Default icons are required for TinyMCE 5.3 or above
import "tinymce/icons/default";
import "tinymce/models/dom";
import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/autolink";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/autosave";
import "tinymce/plugins/charmap";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/directionality";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/help";
import "tinymce/plugins/image";
import "tinymce/plugins/importcss";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/media";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/preview";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/save";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/table";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/wordcount";
// Any plugins you want to use has to be imported
// A theme is also required
import "tinymce/themes/silver";

/**
 * Load css from lib as string
 * @see https://www.tiny.cloud/docs/advanced/usage-with-module-loaders/webpack/webpack_es6_npm/
 */
export const tinyMceOxideSkinCss = require("tinymce/skins/ui/oxide/skin.min.css").default.toString();
export const tinyMceOxideUiCss = require("tinymce/skins/ui/oxide/content.inline.min.css").default.toString();
export const tinyMceContentCss = require("tinymce/skins/content/default/content.min.css").default.toString();
